import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { setInterviewInvites } from 'slices/interviewInviteSlice';
import { acceptInterviewInvites, rejectInterviewInvites, fetchInterviewInvites, interviewInvitesSelector } from 'slices/interviewInviteSlice';
import Swal from 'sweetalert2';
import InterviewInviteTable from './InterviewInviteTable';

const InterviewInvite = () => {
    const { InterviewInvite, loader } = useSelector(interviewInvitesSelector);
    const [statusMessage, setStatusMessage] = useState();
    const [status, setStatus] = useState();
    const [isChecked, setIsChecked] = useState(false);
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);
    const [token, setToken] = useState(params?.get("token"));

    const handleCheckbox = () => {
        setIsChecked(!isChecked);
    };
    useEffect(() => {
        dispatch(fetchInterviewInvites(token, submitCallback));
        return () => {
            dispatch(setInterviewInvites({}));
        };
    }, [token]);

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            });
            setStatusMessage(message);
        } else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
            setStatusMessage(message);
            setStatus(status);
        }
    };

    function AcceptInvite() {
        dispatch(acceptInterviewInvites(token, submitCallback));
        setStatus(status);
        const isAutoAssign = InterviewInvite?.appointment_details?.auto_assign === 1 && InterviewInvite?.invite_details?.interpreter?.auto_assign === 1;

        // Swal.fire({
        //     title: "Appointment Accepted!",
        //     icon: "success",
        // });
        Swal.fire({
            title: isAutoAssign ? "Appointment Assigned!" : "Thanks for Responding!",
            text: isAutoAssign
                ? "Thanks for accepting the appointment. It has been assigned to you and you can add it to your calendar"
                : "Thanks for letting us know. Please note you're not yet assigned. Standby to hear back from the team on this assignment",
            icon: "success",
        });
        dispatch(fetchInterviewInvites(token, submitCallback));
        // setTimeout(() => {
        //     window.location.reload();
        // }, 2000);
    }

    function RejectInvite() {
        dispatch(rejectInterviewInvites(token, submitCallback));
        Swal.fire({
            title: "Appointment Rejected!",
            // text: statusMessage,
            icon: "error",
        });
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }

    if (loader) {
        return (
            <div className="loader_wrapper">
                <Spinner size="xl">
                    Loading...
                </Spinner>
            </div>
        );
    }
    const inviteStatus = InterviewInvite?.invite_details?.status;
    const assignedInterpreterId = InterviewInvite?.interpreter_id;
    const currentInterpreterId = InterviewInvite?.invite_details?.interpreter?.id;
    const appointmentStatus = InterviewInvite?.status;
    console.log('InterviewInvitessss',InterviewInvite);
    return (
        <>
            {statusMessage === 'Data retrieved successfully.' && InterviewInvite ? (
                <div className='main-freePage'>
                    <img src="/images/logo.png" alt="" />
                    <div className='table_wrapper'>
                        <div className="appointment-container">
                            <div className="appointment-header">
                                <p>Appt <b className='font-semibold'># {InterviewInvite?.appid}</b></p>
                            </div>
                            <InterviewInviteTable InterviewInvite={InterviewInvite} />
                            {/* {InterviewInvite?.status === 'available' && (
                                <div className='str_row'>
                                    <div className="agreement-section"> */}
                                        {/* <label className="custom-checkbox checkbox">
                                            <input type="checkbox" name="agreement" id="agreement" checked={isChecked} onChange={handleCheckbox} />
                                            <span className="checkmark"></span>
                                        </label> */}
                                        {/* <label htmlFor="agreement">I Accept the <Link to="#">Agreement</Link></label> */}
                                    {/* </div>
                                    <div className="button-group">
                                        <button className="main_button seagreen" onClick={AcceptInvite}>
                                            Accept
                                        </button>
                                        <button className="table_delete" onClick={RejectInvite}>Decline</button>
                                    </div>
                                </div>
                            )} */}

                            {/* {InterviewInvite?.status === 'available' ? (
                                <div className='str_row'>
                                <div className="agreement-section">
                                </div>
                                <div className="button-group">
                                    <button className="main_button seagreen" onClick={AcceptInvite}>
                                    Accept
                                    </button>
                                    <button className="table_delete" onClick={RejectInvite}>Decline</button>
                                </div>
                                </div>
                            ) : (
                                <div className='str_row'>
                                <p style={{ color: 'red', fontWeight: 500 }}>
                                    This appointment has already been assigned to someone else.
                                </p>
                                </div>
                            )} */}

                            {InterviewInvite?.status === 'available' && inviteStatus !== 'accepted' ? (
                                <div className='str_row'>
                                    <div className="agreement-section">
                                    </div>
                                    <div className="button-group">
                                        <button className="main_button seagreen" onClick={AcceptInvite}>
                                            I'm Available
                                        </button>
                                        <button className="table_delete" onClick={RejectInvite}>
                                            Decline
                                        </button>
                                    </div>
                                </div>
                            ) : inviteStatus === 'accepted' && assignedInterpreterId === currentInterpreterId  ? (
                                <div className='str_row'>
                                    <p style={{ color: 'green', fontWeight: 500 }}>
                                        Appointment invite accepted successfully.
                                    </p>
                                </div>
                            ) : inviteStatus === 'accepted' && InterviewInvite?.status !== 'assigned' ? (
                                <div className='str_row'>
                                    <p style={{ color: 'green', fontWeight: 500 }}>
                                        Appointment invite accepted successfully.
                                    </p>
                                </div>
                            ) : InterviewInvite?.status === 'assigned' ? (
                                <div className='str_row'>
                                    <p style={{ color: 'red', fontWeight: 500 }}>
                                        This appointment has already been assigned to someone else.
                                    </p>
                                </div>
                            ) : null}

                        </div>
                    </div>
                </div>
            ) : statusMessage === 'Page Expired' ? (
                <div className="error-page-container">
                    <img src="/images/logo.png" alt="" />
                    <h4>OOps! {statusMessage}</h4>
                    <Link to="/" className="main_button mt-5">
                        Go to home page
                    </Link>
                </div>
            ) : (
                <div className="error-page-container">
                    <img src="/images/logo.png" alt="" />
                    <h4>Oopps! The page you were looking for doesn't exist.</h4>
                    <p>
                        <Link to="/" className="button">
                            Go to home page
                        </Link>
                    </p>
                </div>
            )}
        </>
    );
};

export default InterviewInvite;
